var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCookingTime(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 13,
    viewBox: "0 0 12 13",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_30_680)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5 1.5H7",
    stroke: "#6C6C6C",
    strokeWidth: 1.17748,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 12.0886C8.53429 12.0886 10.5887 10.0342 10.5887 7.49988C10.5887 4.96559 8.53429 2.91114 6 2.91114C3.46571 2.91114 1.41126 4.96559 1.41126 7.49988C1.41126 10.0342 3.46571 12.0886 6 12.0886Z",
    stroke: "#6C6C6C",
    strokeWidth: 1.17748,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.01949 8.66982C3.24476 9.20828 3.6117 9.67565 4.08131 10.0223C4.55092 10.3689 5.10567 10.5818 5.6866 10.6384C6.26753 10.6951 6.85295 10.5932 7.38065 10.3438C7.90834 10.0943 8.35861 9.7066 8.6836 9.22176C9.00858 8.73692 9.19616 8.1731 9.22638 7.5902C9.2566 7.0073 9.12835 6.4271 8.85525 5.91125C8.58214 5.3954 8.17439 4.96317 7.67532 4.66049C7.17625 4.35781 6.60451 4.19598 6.02084 4.19221L5.99994 7.42291L3.01949 8.66982Z",
    fill: "#0C995E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_30_680"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCookingTime);
export default __webpack_public_path__ + "static/media/cookingTime.dd31b6970bcff766f3fa3286d2d9dfdc.svg";
export { ForwardRef as ReactComponent };